import InputAdornment from "@material-ui/core/InputAdornment";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";
import { HasChildren, PlainFunctionComponent } from "../../types";
import { doNothing, isArray } from "../../util";
import { EndAdornmentContent, EndAdornmentContentProps } from "../EndAdornmentContent";

export type EndAdornmentProps = Omit<EndAdornmentContentProps, "onClear"> & HasChildren;

export const EndAdornment: PlainFunctionComponent<EndAdornmentProps> = ({ children, className, disabled, disableClearButton, focus, value, ...props }) => {
    const classes = useStyles();
    return (
        <InputAdornment className={clsx(className, classes.endAdornment)} position="end">
            {/* trick the original component rather copy it as this is a special case using the original items */}
            {!focus && (
                <EndAdornmentContent
                    className={clsx({ [classes.iconOverride]: !disabled })}
                    disabled={disabled}
                    disableClearButton={disableClearButton}
                    focus={focus}
                    onClear={doNothing}
                    value={isArray(value) && value.length === 0 ? undefined : value}
                    {...props}
                />
            )}
            {children}
        </InputAdornment>
    );
};

const useStyles = makeStyles(
    createStyles({
        endAdornment: {
            position: "absolute",
            padding: 0,
            right: 12,
            top: 24,
        },
        iconOverride: {
            margin: 0,
        },
    }),
);
